<template>
	<div class="spinner">
		<svg style="fill: currentColor;" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<path class="path1" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
			<path class="path2" d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" />
		</svg>
	</div>
</template>

<script>
export default {
	name: "Spinner",
};
</script>

<style scoped>

	.spinner {
		display: flex; 
		height: 100dvh;
		align-items: center;
		justify-content: center;
		color: var(--clr-accent-primary, #F7B500);
	}

	.path1 {
		opacity: 0.25;
	}

	.path2 {
		transform-origin:center;
		animation: spinner_spin .75s infinite linear;
	}
	
	@keyframes spinner_spin {
		100% {
			transform: rotate(360deg);
		}
	}

</style>
